module.exports = __webpack_public_path__ + "static/media/r2.d3bb3f59.png";